<app-master-data-table [data]="masterCommonService.packingTypesList" [columns]="transportmodeColumns"
  title="Transport Modes List" addButtonLabel="Transport Mode" (add)="openAddUpdateTransportModeDialog('add')"
  (update)="openAddUpdateTransportModeDialog('update', $event)" (delete)="deleteTransportMode($event)">
</app-master-data-table>